import React, { Component } from 'react'
import './event-report.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faDownload } from '@fortawesome/free-solid-svg-icons'
import { faHome, faSpinner } from '@fortawesome/free-solid-svg-icons'
import AssessmentChart from '../assessment-chart/assessment-chart'
import EventStudents from '../event-students/event-students'
import ClassFilter from '../class-filter/class-filter'
import PerformaceReport from '../performance-report/performance-report'
import EvalutionReport from '../evaluation-report-v2/evaluation-report'
import EventStudentWinners from '../event-student-winners/event-student-winners'
import moment from 'moment'
import SchoolApi from '../../../apis/school'
import { Modal, ModalBody } from 'reactstrap'
import { getImageSource } from '../../../utility/image-source'
import { ImageConstants } from '../../../constants/constants'
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component'
import CommonApi from '../../../apis/common'
import SessionCache from '../../routes/session-cache'
import DownloadCertificate from '../download-certificate/download-certificate'
import SchoolUserApi from '../../../apis/student'
import LearningOutcome from '../learning-outcome/learning-outcome';
import ReactTooltip from 'react-tooltip'
let { Parser } = require('json2csv');




class EventReport extends Component {
  state = {
    selectedClass: 'All',
    showDetails: false,
    showBookSessionSuccess: false,
    liveEventHomeworkDetail: []
  }
  data = []
  displayScreen = 'final-assessment'
  constructor(props) {
    super(props)
    const { event } = this.props
    if (event) {
      const eventProgress = this.getEventProgress(event)
      this.state.eventProgress = eventProgress
    }

    this.getClassDetails()
    this.getTeacherCertificate()
    this.getSchoolReport()
    this.getEventReport()
    this.getLiveEventHomeworkDetail()
  }

  getClassDetails() {
    let payload = { limit: 100 }

    SchoolApi.getClassAndBoard(payload)
      .then(school => {
        let classes = []
        for (let i = 0; i < school.classes.length; i++) {
          classes.push({
            title: school.classes[i].name,
            value: school.classes[i].name
          })
        }

        this.setState({ classes: classes })
      })
      .catch(err => { })
  }

  getEventProgress = event => {
    let eventEndDate = ''
    const today = moment()
    if (event.step3 && event.step3.endTime) {
      eventEndDate = moment(
        moment(event.step3.endTime, 'YYYY-MM-DDThh:mm:ssZ').format(
          'YYYY-MM-DD'
        ),
        'YYYY-MM-DD'
      ).add(1, 'days')
    }


    let eventStartTime = '', eventEndTime = ''

    if (event.step3 && event.step3.startTime) {
      eventStartTime = moment(
        moment(event.step3.startTime, 'YYYY-MM-DDThh:mm:ssZ').format(
          'YYYY-MM-DD'
        ),
        'YYYY-MM-DD'
      )
    }

    if (event.step3 && event.step3.endTime) {
      eventEndTime = moment(
        moment(event.step3.endTime, 'YYYY-MM-DDThh:mm:ssZ').format(
          'YYYY-MM-DD'
        ),
        'YYYY-MM-DD'
      )
    }


    //console.log(moment(today).isBetween(eventStartTime, eventEndTime))

    if (event.resultAnnounced) {
      return 'resultAnnounced'
    } else if (event.step3 && today.isSameOrAfter(eventEndDate)) {
      return 'final'
    } else if (moment(today).isBetween(eventStartTime, eventEndTime) || event.isSingleStepEvent) {
      return 'final_live'
    } else {
      return 'baseline'
    }
  }

  onSelectClass = title => {
    this.setState(
      {
        selectedClass: title || 'All'
      },
      _ => {
        const {
          showDetails,
          showEvaluationReport,
          showPerformanceReport,
          showWinnersList,
          showLearningOutcome
        } = this.state
        const { event } = this.props
        const payload = {}
        payload.isConsolidatedReport = event.showOverallReport
        if (title) payload.class = title
        if (showDetails) {
          this.eventStudents.setSelectedClass(payload)
        } else if (showEvaluationReport) {
          this.evaluationReport.getEvaluationReport(payload)
        } else if (showPerformanceReport) {
          this.performanceReport.getEventStudentPerformanceList(payload)
        } else if (showWinnersList) {
          this.studentWinners.getEventWinnersList(payload)
        } else {
          if (!showLearningOutcome) {
            this.getEventReport(payload)
            this.assessmentChart.getEventPerformaceReport(payload)
            this.assessmentChart.getEventNationalAverage(payload)
            this.assessmentChart.getEventWinnersList(payload)
          }
        }
      }
    )
  }

  getEventReport = (payload = {}) => {
    const { event } = this.props
    payload.eventId = event._id
    this.setState({
      isLoading: true
    })
    SchoolUserApi.getEventReport(payload)
      .then(response => {
        console.log(response)
        this.setState({
          eventReport: response
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  getLiveEventHomeworkDetail = (payload = {}) => {
    let userInfo = SessionCache.getUser()
    const { event } = this.props
    payload.eventId = event._id
    payload.schoolCode = userInfo?.schoolInfo?.schoolCode || ''
    this.setState({
      isLoading: true
    })

    SchoolApi.getLiveEventHomeworkDetail(payload).then(res => {
      console.log(res)
      this.setState({
        isLoading: false
      })
      this.setState({ liveEventHomeworkDetail: res.homeworkDetailpayload })

    }).catch(err => {
      console.log(err)
      this.setState({
        isLoading: false
      })
    })



  }

  viewDetails = (screen, showPopup, className) => {
    this.reportScreen = screen
    console.log(screen, showPopup, className)
    if (showPopup === false) {
      if (screen === 'learningOutcome') {
        this.setState({
          showLearningOutcome: true,
          selectedClass: className
        })
      }
      if (screen === 'winners') {
        this.setState({
          showWinnersList: true
        })
        return
      }
      if (screen === 'download') {
        this.setState({
          showDownloadScreen: true
        })
        return
      }
    } else {
      this.setState({
        showClassSelectionPopup: true
      })
    }
  }

  onSelectClassViewDetails = className => {
    this.setState({
      selectedClassName: className
    })
  }

  onShowBookSessionSuccess = _ => {
    this.setState({
      showBookSessionSuccess: true
    })
  }

  onCloseClassSelectionPopup = _ => {
    this.setState({
      showClassSelectionPopup: false,
      showBookSessionSuccess: false
    })
  }

  onViewDetails = _ => {
    const { eventProgress, selectedClassName } = this.state
    const screen = this.reportScreen
    if (eventProgress !== 'baseline') {
      if (screen === 'winners') {
        this.setState({
          selectedClass: selectedClassName,
          showWinnersList: true,
          showClassSelectionPopup: false
        })
        return
      }
      if (screen === 'performance') {
        this.setState({
          selectedClass: selectedClassName,
          showPerformanceReport: true,
          showClassSelectionPopup: false
        })
        return
      }
      if (screen === 'evaluation') {
        this.setState(
          {
            selectedClass: selectedClassName,
            showClassSelectionPopup: false
          },
          _ => {
            this.assessmentChart.scrollToPosition()
          }
        )
        return
      }
    }
    this.setState({
      selectedClass: selectedClassName,
      showDetails: true,
      showClassSelectionPopup: false
    })
  }

  goBack = _ => {
    const {
      showDetails,
      showPerformanceReport,
      showEvaluationReport,
      showWinnersList,
      selectedClassName,
      selectedClass,
      showDownloadScreen,
      showLearningOutcome
    } = this.state
    if (
      !showDetails &&
      !showWinnersList &&
      !showEvaluationReport &&
      !showPerformanceReport &&
      !showDownloadScreen &&
      !showLearningOutcome
    ) {
      this.props.closeReport()
    } else {
      this.setState({
        selectedClass: selectedClassName ? '' : selectedClass,
        showDetails: false,
        showEvaluationReport: false,
        showPerformanceReport: false,
        showWinnersList: false,
        showDownloadScreen: false,
        showLearningOutcome: false
      })
    }
  }
  renderBookSessionSuccess = _ => {
    return (
      <Modal
        className='cw-custom-modal book-session-success'
        isOpen={true}
        toggle={this.onCloseClassSelectionPopup}
        size={'lg'}
      >
        <ModalBody>
          <div className='header-image text-center'>
            <img src={getImageSource(ImageConstants.GREEN_TICK_V2)} />
          </div>
          <div className='row px-4 header-text text-center'>
            Your request is successfully captured. Our expert will reach out to
            you soon.
          </div>
          <div className='text-center'>
            <button
              className={`cw-button-primary`}
              onClick={this.onCloseClassSelectionPopup}
            >
              Close
            </button>
          </div>
        </ModalBody>
      </Modal>
    )
  }
  renderClassSelectionPopup = _ => {
    const { classes, selectedClassName } = this.state
    return (
      <Modal
        className='cw-custom-modal class-filter-report'
        isOpen={true}
        toggle={this.onCloseClassSelectionPopup}
        size={'lg'}
      >
        <ModalBody>
          <div className='row'>
            <div className='col text-right'>
              <img
                className='close-icon cursor-pointer'
                onClick={this.onCloseClassSelectionPopup}
                src={getImageSource(ImageConstants.CROSS)}
              />
            </div>
          </div>
          <div className='header-text text-center'>
            <span>Select the class for detail view</span>
          </div>
          <div className='row px-4 class-container'>
            {classes?.map((c, index) => (
              <div
                key={index}
                onClick={_ => this.onSelectClassViewDetails(c.title)}
                className={`class-title cursor-pointer py-2 mr-4 ${selectedClassName ===
                  c.title && 'class-active'}`}
              >
                {c.title}
              </div>
            ))}
          </div>
          <div className='text-center'>
            <button
              className={`cw-button-primary ${!selectedClassName ? 'cw-button-disabled' : ''
                }`}
              onClick={this.onViewDetails}
            >
              Continue
            </button>
          </div>
        </ModalBody>
      </Modal>
    )
  }

  downloadReport = () => {
    const link = document.createElement('a')
    link.href =
      'https://countingwell-doubts-assets-dev.s3.ap-south-1.amazonaws.com/performance/Countignwell_School_1651141586401.pdf'
    link.target = '_blank'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  openLink = link => {
    window.open(link, '_blank')
  }

  getTeacherCertificate = _ => {
    const { event } = this.props
    const payload = { eventId: event._id }
    SchoolApi.getTeacherCertificate(payload)
      .then(response => {
        this.setState({
          teacherCertificate: response.url
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  getSchoolReport = _ => {
    const { event } = this.props
    const payload = { eventId: event._id }
    SchoolApi.getSchoolPdfReport(payload)
      .then(response => {
        this.setState({
          schoolPdfReport: response.url
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  bookSession = _ => {
    let userInfo = SessionCache.getUser()
    const payload = {
      type: 'BOOK_SESSION_WITH_EXPERTS',
      schoolId: userInfo?.schoolInfo?.schoolCode || '',
      userId: userInfo?.id || ''
    }
    CommonApi.addMiscellaneous(payload)
      .then(response => {
        this.onShowBookSessionSuccess()
      })
      .catch(err => console.log(err))
  }

  showToaster(type, message) {
    this.setState(
      {
        showToaster: true,
        toasterMessage: message,
        toasterType: type
      },
      () => {
        setTimeout(() => {
          this.hideToaster()
        }, 3000)
      }
    )
  }

  hideToaster() {
    this.setState({
      showToaster: false
    })
  }

  assignHomework = _ => {
    let userInfo = SessionCache.getUser()
    const { event } = this.props
    const { classes } = this.state
    const classList = []
    classes.forEach(classDetail => {
      classList.push(classDetail.title)
    })
    window.open(
      `/school/students/homework/assign/${userInfo.schoolInfo.schoolCode}/${event._id}?class=${classList.join(",")}`
    )
  }

  onClickExport = () => {

    if (this.state.exporting) return

    this.setState({ exporting: true })

    let payload = {}

    const { event } = this.props
    payload.eventId = event._id
    payload.type = "ALL_ONBOARDED_STUDENTS"
    this.setState({
      isLoading: true
    })

    SchoolUserApi.getEventStudentList(payload)
      .then(result => {

        let schoolOnboardedStudents = result.response

        if (schoolOnboardedStudents) {

          let csvBuild = []
          for (let i = 0; i < schoolOnboardedStudents.length; i++) {
            let item = schoolOnboardedStudents[i]

            let obj = {
            }
            if (item["schoolId"]) {


              if (item["name"]) {
                obj['Student Name'] = item["name"]
              }

              if (item["gender"]) {
                obj['Gender'] = item["gender"]
              }

              // if (item["alternateBoard"]) {
              //   obj['Board'] = item["alternateBoard"]
              // }

              if (item["class"]) {
                obj['CLASS'] = item["class"]
              }

              // if (item["countryCode"]) {
              //   obj['COUNTRY CODE'] = item["countryCode"]
              // }

              if (item["mobileNumber"]) {
                obj['MOBILE NUMBER'] = item["mobileNumber"]
              }

              if (item["email"]) {
                obj['EMAIL'] = item["email"]
              }

              // if (item["schoolId"]) {
              //   obj['SCHOOL CODE'] = item["schoolId"]
              // }

              //   if (item["schoolName"]) {
              //       obj['SCHOOL NAME'] = item["schoolName"]
              //   }

              if (item["isSubscribed"]) {
                obj['PAYMENT STATUS'] = "Paid"

              } else {
                obj['PAYMENT STATUS'] = "Not Paid"
              }


              if (item["finalAssessment"]["status"] === "COMPLETED") {
                obj["TEST STATUS"] = 'TAKEN'
              } else if (item["finalAssessment"]["status"] === "IN_PROGRESS") {
                obj["TEST STATUS"] = 'NOT TAKEN'
              } else {
                obj["TEST STATUS"] = 'NA'
              }

              // if (item?.subscriptionValidTill ) {
              //     obj['SUBSCRIPTION VALID TILL'] = this.datePipe(item.subscriptionValidTill)
              // }
            }

            csvBuild.push(obj)
          }
          let json2csvParser = new Parser();
          let csv = json2csvParser.parse(csvBuild);

          // console.log(csv);

          let hiddenElement = document.createElement('a');
          hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
          hiddenElement.target = '_blank';
          hiddenElement.download = 'student_onboarded_report_' + (new Date).toISOString() + '.csv';
          hiddenElement.click();
        }
        this.setState({ exporting: false })

      })

      .catch(err => {
        console.log(err)
        this.setState({
          exporting: false
        })
      })


  }

  datePipe(givenDate, isTime = true) {
    if (!givenDate) return "-"
    givenDate = new Date(givenDate).toString()
    const [day, month, date, year, time] = givenDate.split(' ')
    return `${date} ${month}, ${year} ${isTime ? time.substr(0, 5) : ""}`

  }







  render() {
    const {
      selectedClass,
      showDetails,
      showPerformanceReport,
      showEvaluationReport,
      showWinnersList,
      eventProgress,
      showClassSelectionPopup,
      teacherCertificate,
      showDownloadScreen,
      schoolPdfReport,
      eventReport,
      showBookSessionSuccess,
      classes,
      showLearningOutcome
    } = this.state
    const { event } = this.props
    return (
      <div className='performance'>
        <div className='header-container'>
          <div className='back-icon pb-4'>
            <div className='cursor-pointer' onClick={this.goBack}>
              <FontAwesomeIcon icon={faArrowLeft} color='#1C1C1C' />
            </div>
            {teacherCertificate && (
              <div className='certificate-download'>
                <img
                  className='certificate'
                  src={getImageSource(ImageConstants.FLUENT_CERTIFICATE)}
                />
                Certificate of Appreciation{' '}
                <button
                  onClick={_ => this.openLink(teacherCertificate)}
                  className='btn-certificate-download'
                >
                  Download
                </button>
              </div>
            )}
          </div>
          <div className='event-title' onMouseEnter={ReactTooltip.rebuild}>
            <img className='event-image' src={`${event.headerImage}`} />
            <span className='screen-title'>
              {!showLearningOutcome ? event.title + ' ' : ''}
              {showDetails
                ? 'Students'
                : showPerformanceReport
                  ? 'Student Performance - Final Assessment Report'
                  : showEvaluationReport
                    ? 'Student Evaluation Report'
                    : showWinnersList
                      ? 'Students Winners'
                      : showDownloadScreen
                        ? 'Download Certificates'
                        : showLearningOutcome
                          ? 'Learning Outcome Report'
                          : 'Overview'}
            </span>

            {!showDetails &&
              !showPerformanceReport &&
              !showEvaluationReport &&
              !showWinnersList &&
              !showDownloadScreen &&
              !showLearningOutcome && (
                this.state.eventReport ?
                  <strong className="report-buttons1">
                    <img className='cursor-pointer green-download-icon pt-3' onClick={() => { this.onClickExport() }} 
                    src={getImageSource(ImageConstants.GREEN_DOWNLOAD_ICON)} data-tip={'DOWNLOAD STUDENT LIST'} />
                    {/* <button className='cw-button-primary' onClick={() => { this.onClickExport() }}> */}
                      {/* {
                        !this.state.exporting ? <span className='download-icon'> <FontAwesomeIcon icon={faDownload} /><span className='ml-2'>Export to Excel</span></span> :
                          <span>  <FontAwesomeIcon icon={faSpinner} spin /><span className='ml-2'>Exporting</span></span>
                      } */}
                      {
                        !this.state.exporting ? <></> :
                          <span>  <FontAwesomeIcon icon={faSpinner} spin /><span className='ml-2'>Exporting</span></span>
                      }
                    {/* </button> */}
                  </strong>
                  : ""



                // <div className='report-buttons'>
                //   <button
                //     className={`cw-button-primary`}
                //     onClick={this.bookSession}
                //   >
                //     <img
                //       className='button-img'
                //       src={getImageSource(ImageConstants.CALENDAR_WHITE)}
                //     />
                //     Export to Excel
                //   </button>
                //   {schoolPdfReport && (
                //     <button
                //       className={`cw-button-primary`}
                //       onClick={_ => this.openLink(schoolPdfReport)}
                //     >
                //       <img
                //         className='button-img'
                //         src={getImageSource(ImageConstants.PDF_WHITE)}
                //       />
                //       Download PDF Version
                //     </button>
                //   )}
                //   {eventReport &&
                //     eventReport.studentCount > 0 &&
                //     eventProgress === 'resultAnnounced' && (
                //       <button
                //         className={`cw-button-primary`}
                //         onClick={_ => this.viewDetails('download', false)}
                //       >
                //         <span className='download-icon'>
                //           <FontAwesomeIcon icon={faDownload} color='#FFFFFF' />
                //         </span>
                //         Download Student Certificates
                //       </button>
                //     )}
                // </div>
              )}

          </div>




        </div>
        {showLearningOutcome && (
          <ClassFilter
            onSelectClass={this.onSelectClass}
            selectedClass={selectedClass}
          />
        )}
        <div className='container-fluid'>
          {eventReport &&
            classes &&
            classes.length &&
            !showDetails &&
            !showPerformanceReport &&
            !showEvaluationReport &&
            !showWinnersList &&
            !showLearningOutcome &&
            !showDownloadScreen && (
              <AssessmentChart
                selectedClass={selectedClass}
                ref={instance => {
                  this.assessmentChart = instance
                }}
                viewDetails={this.viewDetails}
                eventProgress={eventProgress}
                event={event}
                eventReport={eventReport}
                classes={this.state.classes}
                liveEventHomeworkDetail={this.state.liveEventHomeworkDetail}
              />
            )}


          {showDetails && (
            <>
              <div className='mt-5'>
                <EventStudents
                  reportScreen={
                    eventProgress !== 'baseline'
                      ? this.reportScreen
                      : 'students'
                  }
                  eventProgress={eventProgress}
                  selectedClass={selectedClass}

                  ref={instance => {
                    this.eventStudents = instance
                  }}
                  event={event}
                />
              </div>
            </>
          )}
          {showPerformanceReport && (
            <div className='mt-5'>
              <PerformaceReport
                selectedClass={selectedClass}
                ref={instance => {
                  this.performanceReport = instance
                }}
                event={event}
              />
            </div>
          )}
          {showEvaluationReport && (
            <div className='mt-5'>
              <EvalutionReport
                selectedClass={selectedClass}
                ref={instance => {
                  this.evaluationReport = instance
                }}
                event={event}
              />
            </div>
          )}
          {showWinnersList && (
            <div className='mt-5'>
              <EventStudentWinners
                selectedClass={selectedClass}
                ref={instance => {
                  this.studentWinners = instance
                }}
                event={event}
              />
            </div>
          )}
          {showLearningOutcome && selectedClass !== 'All' && (
            <>
              <div className='row mt-5'>
                <div className='col'>
                  <div className='cw-plain-card cw-plain-card-wrapper-top mr-2 pb-5'>
                    <LearningOutcome
                      selectedClass={selectedClass}
                      event={event}
                    />
                  </div>
                </div>
              </div>

              <div className='row mt-4 assign-homework'>
                <div className='col'>
                  <div className='cw-plain-card cw-plain-card-wrapper-top mr-2 pb-5'>
                    <div className='header-text text-center'>
                      <p>
                        <strong>
                          Assign a free summer refresher course to your all your
                          students between grades 6 – 9 as homework.{' '}
                        </strong>
                      </p>
                      <p>
                        This course will help them further bridge any learning gap
                        and make them better prepared when they come back to school
                        after their summer break. The course includes an AI-driven
                        assessment to identify the learning gaps, and personalized
                        learning modules for each child to fill the same before
                        returning to school from the summer break.
                      </p>
                    </div>
                    <div className='col text-center mx-2'>
                      <button
                        className={`cw-button-primary cw-button-homework`}
                        onClick={this.assignHomework}
                      >
                        Assign Homework
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        {this.state.showToaster ? (
          <div className='custom-toaster-modal'>
            <ToasterComponent
              message={this.state.toasterMessage}
              type={this.state.toasterType}
              position='bottom-center'
            />
          </div>
        ) : (
          ''
        )}
        {showDownloadScreen && (
          <DownloadCertificate event={event} goBack={this.goBack} />
        )}
        {showClassSelectionPopup && this.renderClassSelectionPopup()}
        {showBookSessionSuccess && this.renderBookSessionSuccess()}
        <ReactTooltip ref={el => this.tooltip = el} multiline={true} place='bottom' type='dark' effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />
      </div>
    )
  }
}

export default EventReport
